import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';


/** Directive utilizada para abrir/fechar dropdowns que precisam ficar atachados no body */
@Directive({
    selector: '[sgtDropdownContainerBody]',
})
export class DropdownContainerBodyDirective implements OnInit, OnDestroy {
    private dropdownContainer: any;
    private dropdown: any;

    constructor(private el: ElementRef) { }

    ngOnInit() {
        this.dropdownContainer = jQuery(this.el.nativeElement);
        this.dropdown = this.dropdownContainer.find('.dropdown-menu');

        /** Ao abrir o dropdown */
        this.dropdownContainer.on('show.bs.dropdown', () => {
            jQuery('body').append(this.dropdown.css({
                position: 'absolute',
                left: this.dropdown.offset().left,
                top: this.dropdown.offset().top,
                'z-index': 1050
            }).detach());
        });

        /** Ao fechar o dropdown */
        this.dropdownContainer.on('hide.bs.dropdown', () => {
            this.dropdownContainer.append(this.dropdown.css({
                position: 'relative',
                left: 'auto',
                top: 'auto'
            }).detach());
        });
    }

    ngOnDestroy() {
        this.dropdownContainer?.dropdown('dispose');
    }
}
